import React, { useState, useEffect } from 'react';
import Seo from '../components/seo.js';
import { SiteStructuredData } from '../components/structured-data.js';
import RelatedArticles from '../components/related-articles.js';
import Nav from '../components/nav.js';
import Footer from '../components/footer.js';
import '../styles/global.scss';

const INTERACTIVE = 'a, button, summary, video, .video-container, input, textarea, label';

const Layout = ({ children, background }) => {
    const [cursorPos, setCursorPos] = useState(null);
    const [cursorSize, setCursorSize] = useState('default');
    
    // Checked on every move rather than bound per element, so nested and late-rendered elements are covered.
    const handleMouseMove = (e) => {
        setCursorPos({ x: e.clientX, y: e.clientY });
        setCursorSize(e.target.closest?.(INTERACTIVE) ? 'hover' : 'default');
    }

    useEffect(() => {
        window.addEventListener('mousemove', handleMouseMove);
        document.body.classList.add(window.location.pathname.replace(/^\/|\/$/g, '').replace(/\//g, '-') || 'home');

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        }
    }, []);
    
    return (
        <div className='site-wrapper'>
            <Seo />
            <SiteStructuredData />
            <Nav background={background} />
            { children }
            <RelatedArticles />
            <Footer />
            <div className={`cursor ${cursorSize}`} style={{ left: cursorPos?.x, top: cursorPos?.y }}></div>
        </div>
    )

}

export default Layout